import { oneOf } from './utils/validate'

const roleSchema = oneOf(['anyone', 'siteMember', 'siteMemberAuthor', 'admin'])

export const permissionsSchema = {
  insert: roleSchema,
  read: roleSchema,
  update: roleSchema,
  remove: roleSchema,
}
